import { Router } from '@angular/router';
import { Component, OnInit, OnDestroy, ViewChild, SimpleChanges, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
// import { LocationService } from 'src/app/modules/shared/services/location.service';
import * as _ from 'lodash';
// import { EncDecService } from 'src/app/modules/shared/services/encryption-decryption.service';
// import { SelfResitrationService } from 'src/app/screens/registration/services/self-registration.service';
import { MapComponent } from './components/map/map.component';
import { AppointmentMapService } from './service/appointment-map.service';
import { UtilsService } from 'src/app/modules/shared/services/utils.service';
import { AppointmentV2Service } from '../appointment-table/services/appointment-v2.service';
@Component({
  selector: 'appointment-map',
  templateUrl: './appointment-map.component.html',
  styleUrls: ['./appointment-map.component.scss'],
})
export class AppointmentMapComponent implements OnInit {

  referenceId:any;
  mobile_number:any;
  // pincode;
  confirmBooking = false;
  bookAppointment = true;
  startDate: Date = new Date();
  minDate: Date = new Date();
  maxDate: any;
  fromDate: any;
  toDate:any;
  onlyOdds:any
  centers:any;
  marginClass = false;
  availableSlots:any = [];
  timeSlots:any;
  selectedSiteSlot:any;
  selectedCenterId:any;
  appointment_confirmation_no:any;
  centerList = [];
  stateList = [];
  districtListPermanent = [];
  blockListPermanent = [];
  pincodeListCurrent = [];
  currentLocationVillageList = [];
  subscription:any;
  appointmentForm:any;
  confirmAppointmentDetails:any ={};
  state_name = '';
  district_name = '';
  block_name = '';
  pincode:any = '';
  addressString = '';
  confirmedBookedBeneficiaryList = [];
  slotDateList:any = [];
  activeSlotId = '';
  currentPage=1;
  activeAppointmentId = '';
  showTables = true;
  showLoader = false;
  showSlots = false;
  isCenterSelected = false;
  isUserLoggedIn = false;
  disableSubmit:boolean = false;
  slotSubScription:any;
  centerDetails:any;
  centerName:any;
  @ViewChild('mapcomp') mapComp: any;


  constructor(
    private appointmentV2: AppointmentV2Service,
    private utilsService: UtilsService,
    // private locationService: LocationService,
    private router: Router,
    private appointmentMapService:AppointmentMapService,
    // private encdecService:EncDecService,
    ) { }

    ionViewWillEnter(){
      this.confirmBooking = false;
      this.bookAppointment = true;
      try {
        let data = sessionStorage.getItem('appointment_data');
        // let benData = this.encdecService.get(data);
        // console.log('appointment',benData)
        // let parsedData = JSON.parse(benData);
        // console.log(parsedData)
        // if(this.utilsService.isPresent(benData)){
        //   // console.log('parsed data', parsedData);
        //   this.linkedBeneficiaryList = parsedData;
        //   if(this.linkedBeneficiaryList.length> 0 && this.utilsService.isPresent(this.linkedBeneficiaryList[0].appointmentId)){
        //     this.activeAppointmentId = this.linkedBeneficiaryList[0].appointmentId;
        //     // this.getAppointmentData();
        //   }

        // }else{
        //   this.router.navigate(['/dashboard']);
        // }
      } catch (error) {
        console.log(error);
        this.router.navigate(['/dashboard']);
      }
      // this.loadDropdowns();

      //reset when it load;
      if(this.appointmentForm){
        this.appointmentForm.reset();
      }
      this.timeSlots = [];
      // this.centerList = [];
      this.availableSlots = [];
      this.activeSlotId = '';
      this.isCenterSelected = false;
      // this.appointmentMapService.setResetMapData();

      let tdate = _.clone(this.startDate);
      this.fromDate = _.clone(tdate);
      tdate.setDate(tdate.getDate() + 6);
      this.toDate = _.clone(tdate);

    }

  ngOnInit() {

    // this.selfRegService.setLoginMenu(true);
    this.initappointmentForm();
    // this.getSlotes(null) //dummy data

    // this.appointmentsCapabilityCalculate()
    console.log("",this.appointmentForm.get('center_id').value)
  }

  setCalenderEmptySessions() {
    //console.log('==========',minAgeFilterValue)
    let items = this.timeSlots
    // this.timeSlots.map((items: any) => {
      //set other parameters
      items.addressString = this.makeAddressString(items)
      items.timeString = this.makeTimeString(items);

      //sort dates
      items.sessions.sort(function (a: any, b: any) {
        var dateA: any = new Date(a.date), dateB: any = new Date(b.date);
        return dateA - dateB;
      });

      //set empty calender
      let loopcount = 7;
      if (this.utilsService.isPresent(loopcount) == false || loopcount > 7) loopcount = 7;
      let sessionDate:any = _.clone(this.startDate);
      sessionDate = moment(sessionDate).format('DD-MM-YYYY')
      let newSessions = [];
      let sessionInd = 0;
      let min_age = null;
      let emptyCount = 0;
      for (let index = 0; index < loopcount; index++) {
        // items.sessions.map(sessionItem => {
        let sameDateSession = [];
        let sessionItem = items.sessions[sessionInd];
        if(!this.utilsService.isPresent(sessionItem)) continue;
        // sessionItem = Object.assign(sessionItem,items);
        if (this.utilsService.isPresent(sessionItem))
          sessionItem.available_capacity = Math.round(sessionItem.available_capacity)
        if (this.utilsService.isPresent(sessionItem) && sessionItem.date == sessionDate) {
          // newSessions.push(sessionItem);
          sameDateSession.push(sessionItem)
          sessionInd++;
          if (!min_age && min_age <= 0)
            min_age = sessionItem.min_age_limit;
          let sessionItemCheck = items.sessions[sessionInd];
          while (this.utilsService.isPresent(sessionItemCheck) && sessionItemCheck.date == moment(sessionDate, 'DD-MM-YYYY').format('DD-MM-YYYY')) {
            sameDateSession.push(sessionItemCheck);
            sessionInd++
            sessionItemCheck = items.sessions[sessionInd];
          }
          // maxvaccines = sameDateSession.length;
          sameDateSession.sort((a, b) => (a.vaccine.toLowerCase() > b.vaccine.toLowerCase()) ? 1 : ((b.vaccine.toLowerCase() > a.vaccine.toLowerCase()) ? -1 : 0));
          newSessions.push({date:sessionDate, sessions: sameDateSession});
        } else {
          // newSessions.push([{
          //   date: moment(sessionDate, 'DD-MM-YYYY').format('DD-MM-YYYY'),
          //   available_capacity: 0,
          //   session_id: ''
          // }])
          emptyCount++;
        }
        sessionDate = moment(sessionDate, 'DD-MM-YYYY').add(1, 'days').format('DD-MM-YYYY');
        // })
      }
      // if (min_age && min_age > 0)
      //   items.age_limit = min_age
      // console.log('new session ',newSessions)
      // if (emptyCount == loopcount) {
      //   items.isEmpty = true;
      // } else {
      //   items.isEmpty = false;
      // }
      // items.newSessions = newSessions;
    // })
    this.timeSlots = newSessions;
    // this.centerList = this.centerList.filter((cen: any) => cen.isEmpty == false);
  }


  appointmentsCapabilityCalculate(){
    if(this.availableSlots.length <= 0){
      this.displaySlots = [];
      this.slotDateList = [];
      return;
    }
    let slotuniqdate:any=[];
    let result:any = []
    this.availableSlots.forEach((element:any) => {
      if((slotuniqdate[element.date]) && element.available_capacity != null){
        slotuniqdate[element.date] = (this.utilsService.isPresent(slotuniqdate[element.date]) ? slotuniqdate[element.date] : 0) + (this.utilsService.isPresent(element.available_capacity) ? element.available_capacity : 0);
      } else {
        slotuniqdate[element.date] = (this.utilsService.isPresent(element.available_capacity) ? element.available_capacity : 0);
      }
    });
    Object.keys(slotuniqdate).forEach(function(key) {
      // console.log('----',key, slotuniqdate[key]);
      result.push({date:key,available_capacity:slotuniqdate[key]})
    });
    // console.log(result)
    this.slotDateList = result;
    this.slotDateList.sort(function(a:any, b:any) {
      var dateA:any = new Date(a.date), dateB:any = new Date(b.date);
      return dateA - dateB;
    });
    if(this.slotDateList.length > 0){
      this.showFilterdSlot(this.slotDateList[0].date);
    }
  }

  displaySlots = [];
  showFilterdSlot(date:any){
    let slotResult = this.availableSlots.filter((slot:any) => slot.date == date);
    // console.log(slotResult);
    this.displaySlots = slotResult;
  }

  linkedBeneficiaryList:any = [];
  getLinkedBeneficiary(){
    // this.selfRegService.linkedBeneficiaries().subscribe((res:any) => {
    //   console.log("list of linked users",res)
    //   this.linkedBeneficiaryList = res;
    //   // this.linkedBeneficiaryList.map(ben => {
    //   //   ben.selected = false;
    //   // })
    // })
  }

  selectSlot(slotDetails:any,Forenoon:any){
    if(this.utilsService.isPresent(slotDetails.available_capacity) && slotDetails.available_capacity > 0){
      this.activeSlotId = slotDetails.slot_id;
      this.confirmAppointmentDetails.isForenoon = Forenoon;
      this.confirmAppointmentDetails.slotDetails = slotDetails;
    }
  }

  confirmAppointment(){
    let center_id = this.appointmentForm.get('center_id').value;
    let selectedCenters = this.centerList.filter((cen:any) => cen.center_id == center_id);
    if(!this.utilsService.isPresent(this.confirmAppointmentDetails.slotDetails)){
      // this.utilsService.presentToastError('Select vaccination slots!')
      return;
    }
    let available_capacity = this.confirmAppointmentDetails.slotDetails.available_capacity;
    if(this.linkedBeneficiaryList.length > available_capacity){
      // this.utilsService.presentToastError('Seats not available for given number of users!');
      return;
    }
    if(this.utilsService.isPresent(selectedCenters) && selectedCenters.length > 0){
        this.confirmAppointmentDetails.centerDetails = selectedCenters[0];
        this.confirmBooking = true;
        this.bookAppointment = false;
        this.disableSubmit = false;
    }
    let searchedMap = this.mapComp.searchPlace;
    this.appointmentMapService.setLastMapLocation(searchedMap);

  }

  backClick(){
    this.appointmentMapService.setLastMapLocation('');
  }


  bookMyAppointment() {

    let slotDetails = this.confirmAppointmentDetails.slotDetails;
    // let selectedSlots = this.appointmentForm.get('slot_id').value;
    let center = this.appointmentForm.get('center_id').value;
    let center_id = this.utilsService.isPresent(center[0]) ? center[0] : null;
    if(this.utilsService.isPresent(slotDetails)){
      // let slotDetails = selectedSlots.length > 0 && this.utilsService.isPresent(selectedSlots[0]) ? selectedSlots[0] :null;
      if(this.utilsService.isPresent(slotDetails) && this.utilsService.isPresent(center_id)){

        let beneficiaries:any =[];
        this.linkedBeneficiaryList.map((ben:any) => {
          beneficiaries.push(ben.beneficiary_reference_id);
        })

        let payload:any = {
          "center_id": center_id,
          "date": slotDetails.date,
          "slot_id": slotDetails.slot_id,
          "district_id": slotDetails.district_id,
          "beneficiaries": beneficiaries,
          'time_preference':this.confirmAppointmentDetails.isForenoon ? 'FORENOON' : 'AFTERNOON'
        }
        this.disableSubmit = true;
        if(this.utilsService.isPresent(this.activeAppointmentId)){
          payload['ben_appointment_id'] = this.activeAppointmentId;
          // this.selfRegService.reScheduleAppointment(payload).subscribe(res => {
          //   this.confirmAppointmentDetails.appointment_confirmation_no = res.appointment_confirmation_no;
          //   this.bookAppointment = false;
          //   this.confirmBooking = false;

          //   let data = this.encdecService.set(JSON.stringify(this.confirmAppointmentDetails.appointment_confirmation_no));
          //   sessionStorage.setItem('confirmAppointmentDetails',data);

          //   this.router.navigate(['/appointment/success'])
          // },err => { console.error(err), this.disableSubmit = false;})
        }else{
          // this.selfRegService.scheduleAppointment(payload).subscribe(res => {
          //   this.confirmAppointmentDetails.appointment_confirmation_no = res.appointment_confirmation_no;
          //   // this.appointment_confirmation_no = res.appointment_confirmation_no;
          //   this.bookAppointment = false;
          //   this.confirmBooking = false;
          //   // this.thankyouMsg = true;

          //   let data = this.encdecService.set(JSON.stringify(this.confirmAppointmentDetails.appointment_confirmation_no));
          //   sessionStorage.setItem('confirmAppointmentDetails',data);

          //   this.router.navigate(['/appointment/success'])
          // },err => {console.error(err); this.disableSubmit = false;})
        }
      }
    }else{
      // this.utilsService.presentToastError('Invalid vaccination slots!')
    }
  }

  getSlotes(event:any){

    let center = this.appointmentForm.get('center_id').value;
    // console.log(center)
    let center_id = this.utilsService.isPresent(center) && this.utilsService.isPresent(center[0]) ? center[0] : null;
    if(this.utilsService.isPresent(center_id)){ //dummy data
      this.activeSlotId = '';
      this.confirmAppointmentDetails.slotDetails = null;
      this.marginClass = true;
      let currDate = _.clone(this.startDate);//new Date('08-JAN-2021');
      this.fromDate = _.clone(currDate);
      let from = ('0'+currDate.getDate()).slice(-2)+'-'+ ('0'+(currDate.getMonth()+1)).slice(-2)+'-'+currDate.getFullYear();
      currDate.setDate(currDate.getDate() + 6);
      this.toDate = _.clone(currDate);
      let to = ('0'+currDate.getDate()).slice(-2) +'-'+ ('0'+(currDate.getMonth()+1)).slice(-2) +'-'+currDate.getFullYear();

      //get slotes api call
      let payload = {
        center_id : center_id,
        from :from,
        to:to
      }
      if(this.slotSubScription){
        this.slotSubScription.unsubscribe()
      }
      this.availableSlots = [];
      this.showLoader = true;
      //dummy data
      this.slotSubScription = this.appointmentV2.getSlots(payload).subscribe(res => {
        if(!this.utilsService.isPresent(res) || !this.utilsService.isPresent(res.centers)){
          this.showLoader = false;
          this.showSlots = true;
          // this.centerDetails = null
          return;
        }
        //dummy data
        // this.timeSlots = {
        //   "center_id": 1234,
        //   "name": "District General Hostpital",
        //   "name_l": "",
        //   "address": "45 M G Road",
        //   "address_l": "",
        //   "state_name": "Maharashtra",
        //   "state_name_l": "",
        //   "district_name": "Satara",
        //   "district_name_l": "",
        //   "block_name": "Jaoli",
        //   "block_name_l": "",
        //   "pincode": "413608",
        //   "lat": 28.7,
        //   "long": 77.1,
        //   "from": "09:00:00",
        //   "to": "18:00:00",
        //   "fee_type": "Free",
        //   "vaccine_fees": [
        //     {
        //       "vaccine": "COVISHIELD",
        //       "fee": "250"
        //     }
        //   ],
        //   "sessions": [
        //     {
        //       "session_id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        //       "date": "12-05-2021",
        //       "available_capacity": 0,
        //       "available_capacity_dose1": 25,
        //       "available_capacity_dose2": 25,
        //       "min_age_limit": 18,
        //       "vaccine": "COVISHIELD",
        //       "slots": [
        //         "FORENOON",
        //         "AFTERNOON"
        //       ]
        //     },
        //     {
        //       "session_id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        //       "date": "12-05-2021",
        //       "available_capacity": 10,
        //       "available_capacity_dose1": 25,
        //       "available_capacity_dose2": 25,
        //       "min_age_limit": 18,
        //       "vaccine": "Covaxin",
        //       "slots": [
        //         "FORENOON",
        //         "AFTERNOON"
        //       ]
        //     },
        //     {
        //       "session_id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        //       "date": "13-05-2021",
        //       "available_capacity": 50,
        //       "available_capacity_dose1": 25,
        //       "available_capacity_dose2": 25,
        //       "min_age_limit": 18,
        //       "vaccine": "COVISHIELD",
        //       "slots": [
        //         "FORENOON",
        //         "AFTERNOON"
        //       ]
        //     },
        //   ]
        // }//
        this.timeSlots = res.centers; //dummy data

        this.centerDetails = _.cloneDeep(this.timeSlots);
        this.centerDetails.addressString = this.makeAddressString(this.centerDetails)
        if(this.timeSlots.sessions.length > 0){
          let sessions:any = []
          this.timeSlots.sessions.map((sessionItem:any)=> {
            sessions.push(Object.assign(sessionItem,this.timeSlots));
          })
          this.timeSlots = sessions;
          // console.log("timeslot", this.timeSlots)
        }
        // this.setCalenderEmptySessions()
        // console.log(this.timeSlots)

        // this.timeSlots = this.timeSlots.timeslots;
        this.availableSlots = _.clone(this.timeSlots);
        this.availableSlots.map((item:any) => { item.day = moment(item.date,'DD-MM-YYYY').format('ddd'), item.dateDisplay = moment(item.date,'DD-MM-YYYY').format('DD MMM YYYY')})
        this.availableSlots.sort(function(a:any, b:any) {
          var dateA:any = new Date(a.date), dateB:any = new Date(b.date);
          return dateA - dateB;
        });
        this.showLoader = false;
        this.showSlots = true;

        // if(this.availableSlots.length == 0){
        //   this.utilsService.presentToastError('Can not find slot records!')
        // }
        // this.appointmentsCapabilityCalculate();
      },(err:any) => { //dummy data
        this.showLoader = false;
        this.showSlots = false;
      })

    }//dummy data
  }

  getAppointmentData(){
    this.linkedBeneficiaryList = [];
    // this.selfRegService.getAppointments().subscribe( res => {
    //   let data = res.appointments.filter(app => app.appointment.appointment_confirmation_no == this.activeAppointmentId)
    //   if(data && data.length > 0){
    //     this.linkedBeneficiaryList = data[0].beneficiaries;
    //   }else{
    //     // this.utilsService.presentToastError("Cant find Appointment Details.")
    //     this.router.navigate(['/dashboard']);
    //     return;
    //   }
    // })
  }


  loadDropdowns(){
    // this.locationService.getStates().subscribe(res => {
    //   this.stateList = res;
    // })
  }

  // ngOnDestroy(){
  //   if(this.subscription)
  //   this.subscription.unsubscribe();
  // }

  relLoadMap() {
    this.mapComp.searchPlace = '';
    this.appointmentForm.reset();
    this.appointmentForm.get('center_id').reset()
  }

  loadCentersByPincode(){
    // this.appointmentForm.get('dateFilter').setValue('');
    let pincode = this.appointmentForm.get('pincode').value;
    this.getAddressString(null,null,null,pincode)
    if(this.utilsService.isPresent(pincode)){

      // this.selfRegService.getCenterByPin(pincode).subscribe(res => {

      //   if(this.utilsService.isPresent(res.centers))
      //     this.centerList = res.centers;
      //   else
      //    this.centerList = [];

      //   if(this.centerList.length == 0){
      //     this.utilsService.presentToastError('Can not find center records!')
      //   }
      //   this.centerList.sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : ((b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0));
      // }, error => {
      //     console.log('error',error)
      // })
    }
  }

  loadCentersByDistrictId(){
    let district_id = this.appointmentForm.get('district_id').value;
    if(this.utilsService.isPresent(district_id)){
      // this.selfRegService.getCenterByDistrictId(district_id).subscribe(res => {
      //   console.log(res);
      //   if(this.utilsService.isPresent(res.centers))
      //     this.centerList = res.centers;
      //   else
      //    this.centerList = [];

      //    if(this.centerList.length == 0){
      //     this.utilsService.presentToastError('Can not find center records!')
      //   }
      //   this.centerList.sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : ((b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0));

      // })
    }
  }

  loadCentersByBlockId(){
    let block_id = this.appointmentForm.get('block_id').value;
    if(this.utilsService.isPresent(block_id)){
      // this.selfRegService.getCenterByBlockId(block_id).subscribe(res => {
      //   console.log(res);
      //   if(this.utilsService.isPresent(res.centers))
      //     this.centerList = res.centers;
      //   else
      //    this.centerList = [];

      //    if(this.centerList.length == 0){
      //     this.utilsService.presentToastError('Can not find center records!')
      //   }
      //   this.centerList.sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : ((b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0));

      // })

    }
  }

  loadCentersByStateId(){
    let state_id = this.appointmentForm.get('state_id').value;
    if(this.utilsService.isPresent(state_id)){
      // this.selfRegService.getCenterByStateId(state_id).subscribe(res => {
      //   console.log(res);
      //   if(this.utilsService.isPresent(res.centers))
      //     this.centerList = res.centers;
      //   else
      //    this.centerList = [];

      //    if(this.centerList.length == 0){
      //     this.utilsService.presentToastError('Can not find center records!')
      //   }
      //   this.centerList.sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : ((b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0));

      // })

    }
  }

  loadCentersByAvailableData(){
    this.appointmentForm.markAllAsTouched();
    let pincode = this.appointmentForm.get('pincode').value;
    let block_id = this.appointmentForm.get('block_id').value;
    let district_id = this.appointmentForm.get('district_id').value;
    let state_id = this.appointmentForm.get('state_id').value;
    this.appointmentForm.get('center_id').setValue(null);
    this.isCenterSelected = false;
    this.confirmAppointmentDetails.slotDetails = null;
    this.activeSlotId = '';
    this.centerList = [];
    this.availableSlots = [];
    if(!this.showTables)
    this.showTables = true;

    if(this.utilsService.isPresent(pincode)){
      this.loadCentersByPincode();
    }else if(this.utilsService.isPresent(block_id)){
      this.loadCentersByBlockId();
    }else if(this.utilsService.isPresent(district_id)){
      this.loadCentersByDistrictId();
    // }else if(this.utilsService.isPresent(state_id)){
    //   this.loadCentersByStateId();
    }else{
      // this.utilsService.presentToastError('Please Select Search Criteria!');
    }
  }

  initappointmentForm() {
    this.appointmentForm = new FormGroup({
      state_id:  new FormControl('', Validators.required),
      district_id:  new FormControl('',Validators.required),
      block_id:  new FormControl(''),
      pincode:  new FormControl(''),
      // locality_id:  new FormControl('', Validators.required),
      center_id: new FormControl(''),
      // slot_id: new FormControl(''),
      dateFilter: new FormControl('')
    });
  }

  getPermanentDistrictList(stateId:any){
    this.appointmentForm.get(['district_id']).setValue('');
    this.appointmentForm.get(['block_id']).setValue('');
    this.appointmentForm.get(['pincode']).setValue('');
    this.blockListPermanent = [];
    this.pincodeListCurrent = [];
    this.currentLocationVillageList = [];
    if (stateId) {
      this.getAddressString(stateId)
      // this.locationService.getDistricts(stateId).subscribe((res) => {
      //   this.districtListPermanent = res;
      // })
    }
  }

  foundCentersFromMap(event:any){
    // console.log("foundCentersFromMap",event);
    // this.activeSlotId = '';
    this.centerList = [];
    // this.availableSlots = [];
    // this.confirmAppointmentDetails.slotDetails = null;
    if(this.utilsService.isPresent(event) && this.utilsService.isPresent(event.centers)){
      this.centerList = event.centers;
    }else{
      this.centerList =[];
    }
    this.showTables = true;
  }

  closeAvaibility(){
    this.showSlots = false;
  }

  centerSelected(center:any){
    // console.log('centerSelected',center);
    if(this.utilsService.isPresent(center) && this.utilsService.isPresent(center.center_id)){
      this.appointmentForm.get('center_id').setValue([center.center_id]);
      this.addressString = this.makeAddressString(center);
      if(this.utilsService.isPresent(center) && this.utilsService.isPresent(center.name))
        this.centerName = center.name;
      this.isCenterSelected = true;
      this.getSlotes(null);
    }else{
      this.utilsService.isPresent("Can't get selected Center");
    }

  }

  getPermanentBlockList(districtId:any){
    this.appointmentForm.get(['block_id']).setValue('');
    this.appointmentForm.get(['pincode']).setValue('');
    // this.loadCentersByDistrictId()
    this.pincodeListCurrent = [];
    this.currentLocationVillageList = [];
    this.appointmentForm.get(['block_id']).setValue('');
    if (districtId) {
      this.getAddressString(null,districtId);
      // this.locationService.getBlocks(districtId).subscribe((res) => {
      //   this.blockListPermanent = res;
      // })
    }
  }

  getPincodeByLocation(blockId:any){
    this.appointmentForm.get(['pincode']).setValue('');
    const payLoad = {
      state_id: this.appointmentForm.get(['state_id']).value,
      district_id: this.appointmentForm.get(['district_id']).value,
      block_id: blockId,
    };
    this.currentLocationVillageList = [];
    this.getAddressString(null,null,blockId)
    // this.loadCentersByBlockId();
    // this.selfRegService.getPincodeByLocation(payLoad).subscribe((res) => {
    //   this.pincodeListCurrent = res;
    // })
  }

  //not in use now
  getLocalitybyPincode() {
    this.appointmentForm.get('locality_id').setValue('');
    let pin = this.appointmentForm.get('pincode').value;
    if(this.utilsService.isPresent(pin)) {
      // this.selfRegService.getLocalitybyPincode(pin).subscribe((res:any)=>{
      //   this.currentLocationVillageList = res;
      //   console.log("res", res)
      // })
    }
  }

  //not in user now !!
  filterAppointment(e:any){
    let selectedDate = this.appointmentForm.get('dateFilter').value;
    if(this.utilsService.isPresent(selectedDate)){
      // console.log(selectedDate)
      selectedDate = moment(selectedDate).format('MMM DD YYYY');
      // console.log(selectedDate)

      this.availableSlots = this.timeSlots.filter((slot:any) => moment(slot.date,'MMM DD YYYY').format('MMM DD YYYY') == moment(selectedDate,"MMM, DD YYYY").format('MMM DD YYYY'));
      // this.availableSlots.map(item => { item.date = moment(item.date,'MMM DD YYYY').format('MMM DD YYYY')})
    }
    // console.log(this.availableSlots)
    this.appointmentsCapabilityCalculate()
  }

  getAddressString(state_id = null,district_id = null,block_id = null,pincode = null){
    if(this.utilsService.isPresent(state_id)){
      let states:any = this.stateList.filter((state:any) => state.state_id == state_id);
      if(states.length > 0){
        this.state_name = states[0].state_name
      }
    }

    if(this.utilsService.isPresent(district_id)){
      let dists:any = this.districtListPermanent.filter((dis:any) => dis.district_id == district_id);
      if(dists.length > 0){
        this.district_name = dists[0].district_name;
      }
    }

    if(this.utilsService.isPresent(block_id)){
      let blocks:any = this.blockListPermanent.filter((bloc:any) => bloc.block_id == block_id);
      if(blocks.length > 0){
        this.block_name = blocks[0].block_name;
      }
    }

    if(this.utilsService.isPresent(pincode)){
      this.pincode = pincode;
    }

    this.addressString = '';
    if(this.utilsService.isPresent(this.block_name))
    this.addressString += (this.block_name + ', ')

    if(this.utilsService.isPresent(this.district_name))
    this.addressString += (this.district_name + ', ')

    if(this.utilsService.isPresent(this.state_name))
    this.addressString += (this.state_name + ', ')

    if(this.utilsService.isPresent(this.pincode))
    this.addressString += (this.pincode + '.')

    this.confirmAppointmentDetails.addressString = this.addressString;
    // console.log(this.addressString)
  }

  nextButtonClick(){
    let center = this.appointmentForm.get('center_id').value;
    let center_id = this.utilsService.isPresent(center) && this.utilsService.isPresent(center[0]) ? center[0] : null;
    if(this.utilsService.isPresent(center_id)){
      this.startDate.setDate(this.startDate.getDate() + 7)
      this.currentPage++;
      this.getSlotes(null);
    }
  }
  prevButtonClick(){
    let center = this.appointmentForm.get('center_id').value;
    let center_id = this.utilsService.isPresent(center) &&  this.utilsService.isPresent(center[0]) ? center[0] : null;
    if(this.utilsService.isPresent(center_id)){
      this.startDate.setDate(this.startDate.getDate() - 7)
      this.currentPage--;
      this.getSlotes(null);
    }
  }

  gotoAppointmentScreen(){
    this.confirmBooking = false;
    this.bookAppointment = true;
  }

  makeAddressString(centerDetails:any,addName = false){
    let addressString = '';
      // if(this.utilsService.isPresent(centerDetails.name) && addName) addressString+= centerDetails.name + ', ';
      if(this.utilsService.isPresent(centerDetails.address)) addressString+= centerDetails.address +', ';
      // if(this.utilsService.isPresent(centerDetails.block_name) && centerDetails.block_name.toLowerCase() != "nil" && centerDetails.block_name.toLowerCase() != "nilll" && centerDetails.block_name.toLowerCase() != "not applicable" && centerDetails.block_name.toLowerCase() != "not available" && centerDetails.block_name.toLowerCase() != "na-") addressString += centerDetails.block_name + ', ';
      if(this.utilsService.isPresent(centerDetails.district_name)) addressString+= centerDetails.district_name +', ';
      if(this.utilsService.isPresent(centerDetails.state_name)) addressString+= centerDetails.state_name + ', ';
      if(this.utilsService.isPresent(centerDetails.pincode)) addressString+= centerDetails.pincode + '.';
      return addressString;
  }

  makeTimeString(sessionDetails: any) {
    let from = sessionDetails.from;
    let to = sessionDetails.to;
    return ((moment(from, "hh:mm:ss").isValid() ? moment(from, "hh:mm:ss").format('hh:mmA') : from) + '-' + (moment(to, "hh:mm:ss").isValid() ? moment(to, "hh:mm:ss").format('hh:mmA') : to));
  }


}
